interface AuthResponse {
  code?: string;
  state?: string;
  error?: string;
  error_description?: string;
}

export const validateAuthResponse = (response: AuthResponse, expectedState: string): string => {
  if (response.error) {
    throw new Error(response.error_description || response.error);
  }

  if (!response.code || !response.state) {
    throw new Error('Invalid response received');
  }

  if (response.state !== expectedState) {
    throw new Error('Invalid state parameter');
  }

  return response.code;
};
